import { makeStyles } from "@material-ui/core/styles";
import { secondary } from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  fileIcon: {
    color: secondary,
  },
  actionButton: {
    margin: `0 ${theme.spacing(0.5)}px`,
  },
  actionsColumn: {
    minWidth: 220,
  },
}));

export default useStyles;
